// extracted by mini-css-extract-plugin
export default {"inputContainer":"searchInput_inputContainer__A9VWb","form":"searchInput_form__MRpho","form_input":"searchInput_form_input__S6Gxu","form_submit":"searchInput_form_submit__J0TiH"};